import type { CSSProperties } from 'react';
import type { Column as TanStackColumn } from '@tanstack/react-table';
import type { Column } from './DataTable.js';

export type WpColumnPinning = { left: string[]; right: string[] };

export function buildWpColumnPinning<T>(
  columns: Column<T>[],
  options: { enabled: boolean; pinActionsEnd: boolean },
): WpColumnPinning {
  if (!options.enabled) return { left: [], right: [] };
  const left: string[] = [];
  const right: string[] = [];
  for (const c of columns) {
    if (c.sticky === 'start') left.push(c.key);
    if (c.sticky === 'end') right.push(c.key);
  }
  if (options.pinActionsEnd) right.push('__actions');
  return { left, right };
}

export function wpPinSide(pinned: false | 'left' | 'right' | undefined): 'start' | 'end' | undefined {
  if (pinned === 'left') return 'start';
  if (pinned === 'right') return 'end';
  return undefined;
}

export function getWpPinnedStyles<T>(
  column: TanStackColumn<T, unknown>,
  options: { isHeader?: boolean; stickyEndInsetPx?: number },
): CSSProperties {
  const pinned = column.getIsPinned();
  if (!pinned) return {};
  const zIndex = options.isHeader ? 26 : 20;
  if (pinned === 'left') {
    return {
      position: 'sticky',
      left: column.getStart('left'),
      zIndex,
    };
  }
  const inset = options.stickyEndInsetPx ?? 0;
  const right =
    pinned === 'right' && inset > 0
      ? inset
      : column.getAfter('right');
  return {
    position: 'sticky',
    right,
    zIndex,
  };
}
